import BookingForm from "@/components/BookingForm";

export default function BookingSection({ t, lang, prefill }) {
  return (
    <section
      id="booking"
      className="py-20 sm:py-32 bg-gradient-to-b from-white to-[var(--bg)] border-y border-[var(--border)]"
      data-testid="booking-section"
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-10">
        <div className="text-center mb-12 reveal">
          <span className="label-eyebrow">{t.booking.label}</span>
          <h2 className="font-heading text-4xl sm:text-5xl mt-3 mb-4">
            {t.booking.title}
          </h2>
          <p className="text-lg text-[var(--body)] max-w-xl mx-auto">
            {t.booking.subtitle}
          </p>
        </div>
        <div className="reveal">
          <BookingForm t={t} lang={lang} prefill={prefill} />
        </div>
      </div>
    </section>
  );
}
